import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { AgreementListErpIdCell } from '../components/AgreementListRenderErpId';
import { IAgreementRaw } from '../interfaces/IAgreementRaw';
import { AgreementStatusCell } from '../components/AgreementStatusCell';
import { AgreementNumberCell } from '../components/AgreementNumberCell';
import { AgreementPassportTypeCell } from '../components/AgreementPassportTypeCell';
import { AgreementTermOfExecutionAgreementCell } from '../components/AgreementTermOfExecutionAgreementCell';
import { AgreementNumberOfViolationsAgreementCell } from '../components/AgreementNumberOfViolationsAgreementCell';
import { AgreementKindControlCell } from '../components/AgreementKindControlCell';

export const initialAgreementListTableColumns: ITableColumn<IAgreementRaw>[] = [
  {
    id: 'statusCodeList',
    name: 'Статус',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementStatusCell,
  },
  {
    id: 'agreementNumberList',
    name: '№ соглашения',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementNumberCell,
  },
  {
    id: 'number',
    name: '№ мероприятия',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementListErpIdCell,
  },
  {
    id: 'passportType',
    name: 'Вид мероприятия',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementPassportTypeCell,
  },
  {
    id: 'termOfExecutionAgreement',
    name: 'Срок исполнения',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementTermOfExecutionAgreementCell,
  },
  {
    id: 'numberOfViolations',
    name: 'кол-во нарушений',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementNumberOfViolationsAgreementCell,
  },
  {
    id: 'kno',
    name: 'Орган контроля',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'prosecutorOrganization',
    name: 'Орган прокуратуры',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'kindControl',
    name: 'Вид контроля (надзора)',
    sort: TableColumnSortEnum.NONE,
    renderCell: AgreementKindControlCell,
  },
  {
    id: 'organizationName',
    name: 'Контролируемое лицо',
    sort: TableColumnSortEnum.NONE,
  },
];
